import { InfluencerCloseSVG } from "@/Component/Common/SVGs/CommonSVG"

const CampaignManagementDetailSkeleton = () => {
    return (
        <>
            <div className="flex items-center lg:gap-10 gap-5 lg:mb-8 fixed top-0 py-5 bg-white z-50 left-0 right-0 lg:px-6 px-4 w-full">
                <div className="text-black font-bold z-10 cursor-pointer"><InfluencerCloseSVG /></div>
                <div className="flex items-center gap-1"><div className="rounded bg-gray animate-pulse w-40 h-5"></div> / <div className="rounded bg-gray animate-pulse w-40 h-5"></div></div>
            </div>
            <div className="grid grid-cols-12 gap-2.5">
                <div className="col-span-12 2xl:col-span-6 lg:col-span-7">
                    <div className={`border border-lightGray p-4 rounded-xl mb-2.5`} >
                        <div className="flex items-center justify-between cursor-pointer">
                            <div className="rounded bg-gray animate-pulse w-40 h-4"></div>
                        </div>
                        <div className='mt-2.5'>
                            <div className='flex items-start justify-between'>
                                <div className='flex flex-col gap-1'>
                                    <h3 className='rounded bg-gray animate-pulse w-40 h-6'></h3>
                                    <div className='flex items-center gap-2'>
                                        <span className="rounded bg-gray animate-pulse w-20 h-2"></span>
                                        <span className="rounded-full overflow-hidden">•</span>
                                        <span className="rounded bg-gray animate-pulse w-20 h-2"></span>
                                    </div>
                                </div>
                                <span className="rounded bg-gray animate-pulse w-40 h-2"></span>
                            </div>
                            <div className='flex items-center gap-6 my-6'>
                                <div className="rounded bg-gray animate-pulse w-40 h-4"></div>
                                <div className="rounded bg-gray animate-pulse w-40 h-4"></div>
                            </div>
                            <div className='flex items-center gap-8'>
                                <div className='flex flex-col gap-1'>
                                    <span className="rounded bg-gray animate-pulse w-16 h-6"></span>
                                    <span className='rounded bg-gray animate-pulse w-32 h-4'></span>
                                </div>
                                <div className='flex flex-col gap-1'>
                                    <span className="rounded bg-gray animate-pulse w-16 h-6"></span>
                                    <span className='rounded bg-gray animate-pulse w-32 h-4'></span>
                                </div>
                                <div className='flex flex-col gap-1 max-md:hidden'>
                                    <span className="rounded bg-gray animate-pulse w-16 h-6"></span>
                                    <span className='rounded bg-gray animate-pulse w-32 h-4'></span>
                                </div>
                            </div>
                            <div className='mt-5 pt-5 border-t border-lightGray'>
                                <div className='flex flex-col gap-1'>
                                    <span className="rounded bg-gray animate-pulse w-16 h-4"></span>
                                    <p className="rounded bg-gray animate-pulse w-ful h-20"></p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={`border border-lightGray p-4 rounded-xl mb-2.5`} >
                        <div className="flex items-center justify-between cursor-pointer">
                            <div className="rounded bg-gray animate-pulse w-40 h-4"></div>
                        </div>
                        <div className='mt-2.5'>
                            <div className='flex items-start justify-between'>
                                <div className='flex flex-col gap-1'>
                                    <h3 className='rounded bg-gray animate-pulse w-40 h-6'></h3>
                                    <div className='flex items-center gap-2'>
                                        <span className="rounded bg-gray animate-pulse w-20 h-2"></span>
                                        <span className="rounded-full overflow-hidden">•</span>
                                        <span className="rounded bg-gray animate-pulse w-20 h-2"></span>
                                    </div>
                                </div>
                                <span className="rounded bg-gray animate-pulse w-40 h-2"></span>
                            </div>
                            <div className='flex items-center gap-6 my-6'>
                                <div className="rounded bg-gray animate-pulse w-40 h-4"></div>
                                <div className="rounded bg-gray animate-pulse w-40 h-4"></div>
                            </div>
                            <div className='flex items-center gap-8'>
                                <div className='flex flex-col gap-1'>
                                    <span className="rounded bg-gray animate-pulse w-16 h-6"></span>
                                    <span className='rounded bg-gray animate-pulse w-32 h-4'></span>
                                </div>
                                <div className='flex flex-col gap-1'>
                                    <span className="rounded bg-gray animate-pulse w-16 h-6"></span>
                                    <span className='rounded bg-gray animate-pulse w-32 h-4'></span>
                                </div>
                                <div className='flex flex-col gap-1 max-md:hidden'>
                                    <span className="rounded bg-gray animate-pulse w-16 h-6"></span>
                                    <span className='rounded bg-gray animate-pulse w-32 h-4'></span>
                                </div>
                            </div>
                            <div className='mt-5 pt-5 border-t border-lightGray'>
                                <div className='flex flex-col gap-1'>
                                    <span className="rounded bg-gray animate-pulse w-16 h-4"></span>
                                    <p className="rounded bg-gray animate-pulse w-ful h-20"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-span-12 2xl:col-span-6 lg:col-span-5">
                    <div className="rounded-2xl overflow-hidden bg-lightGray/60">
                        <div className='md:py-6 py-5 px-5 bg-gradient-to-br from-secondary to-primary flex md:items-center justify-between max-md:flex-col max-md:gap-5'>
                            <div className='flex items-center gap-5 text-white'>
                                <div className='min-w-[70px] w-[70px] h-[70px] rounded-full overflow-hidden bg-gray  animate-pulse'></div>
                                <div className='flex flex-col gap-1.5'>
                                    <h5 className='font-semibold lg:text-3xl text-2xl leading-7 bg-gray animate-pulse w-40 h-9'></h5>
                                    <span className='lg:text-2xl text-xl leading-6 bg-gray animate-pulse w-20 h-2'></span>
                                </div>
                            </div>
                        </div>
                        <div className='flex items-center lg:gap-16 gap-8 my-10 px-5'>
                            <div className='flex flex-col gap-0.5'>
                                <h6 className='font-semibold md:text-xl leading-5 bg-gray animate-pulse w-16 h-7'></h6>
                                <span className='md:text-base text-sm bg-gray animate-pulse w-20 h-6'></span>
                            </div>
                            <div className='flex flex-col gap-0.5'>
                                <h6 className='font-semibold md:text-xl leading-5 bg-gray animate-pulse w-16 h-7'></h6>
                                <span className='md:text-base text-sm bg-gray animate-pulse w-20 h-6'></span>
                            </div>
                        </div>
                        <div className="px-5">
                            <h6 className='font-semibold md:text-xl leading-5 bg-gray animate-pulse w-20 h-6 mb-1'></h6>
                            <p className='bg-gray animate-pulse w-full h-20'></p>
                        </div>
                        <div className="px-5 mb-8 mt-10">
                            <h6 className='font-semibold md:text-xl leading-5 mb-5 bg-gray animate-pulse w-20 h-6'></h6>
                            <div className='grid md:grid-cols-3 grid-cols-2 gap-4' >
                                <div className='w-full overflow-hidden rounded-xl aspect-square bg-gray/20 relative'>
                                    <div className='bg-gray animate-pulse w-60 h-60'></div>
                                </div>
                                <div className='w-full overflow-hidden rounded-xl aspect-square bg-gray/20 relative'>
                                    <div className='bg-gray animate-pulse w-60 h-60'></div>
                                </div>
                                <div className='w-full overflow-hidden rounded-xl aspect-square bg-gray/20 relative'>
                                    <div className='bg-gray animate-pulse w-60 h-60'></div>
                                </div>
                            </div>
                        </div>
                        <div className="px-5 mb-5">
                            <div className="bg-gray animate-pulse w-full h-10 rounded-md"></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CampaignManagementDetailSkeleton
